export default __webpack_public_path__ + "static/media/renegotiation.54efeef2.png";